// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/image/home_1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/image/home_5.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/image/icon/slider_prev.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/image/icon/slider_next.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/image/home_5_mobile.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/gh/moonspam/NanumSquareNeo@1.0/nanumsquareneo.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overscroll-behavior-y: none;
}

/* home */
.outer {
  scroll-behavior: smooth;
  height: calc((var(--vh, 1vh) * 100));
  scroll-snap-type: y mandatory;
  overflow-y: scroll;
  position: absolute;
  left: 0;
  top: 0;
}

.outer > div {
  scroll-snap-align: start;
}

.outer::-webkit-scrollbar {
  display: none;
}

.inner {
  height: 100%;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.bg_video {
  height: 100%;
  width: 100%;
}

.inner video {
  object-fit: cover;
}

.bg_home1 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 100% / cover;
  color: #fff;
}

.bg_home2 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 100% / cover;
  color: #fff;
}

.bg-pink {
  background-color: #f4cfdf;
}

* {
  font-family: 'NanumSquareNeo';
}

a {
  text-decoration: none !important;
}

p {
  margin-bottom: 0 !important;
}

.rialto-container {
  /* max-width: 1920px; */
  width: 100%;
  background-color: #fff;
  /* height: 100vh; */
  margin: 0 auto;
  /* padding: 0 120px; */
}

.rialto-content-box {
  padding-top: 98px;
  background-color: #f2f2f2;
  /* max-width: 1680px; */
  max-width: 1765px;
  width: 100%;
  margin: 0 auto;
}

.my-container {
  /* padding-right: 120px; */
  /* width: 100%; */
  flex: 1 1;
}

.opacity-30 {
  background-color: rgba(0, 0, 0, 0.3);
  height: 100%;
  width: 100vw;
  position: absolute;
  top: 0;
  z-index: 0;
}

/* nav */
.nav-bar {
  position: relative;
  background: linear-gradient(178deg, #360530 16%, #a23461 78%);
  /* max-width: 1920px; */
  width: 100%;
  height: 88px;
  padding: 5px 0;
  gap: 0 3rem;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
}

.nav-icons {
  width: 14px;
  height: 16px;
}

.nav-bar.bg-transparent {
  background: none;
}

.nav-bar::after {
  position: absolute;
  bottom: -10px;
  content: '';
  width: 100%;
  height: 10px;
  background-color: #f2f2f2;
  left: 0;
}

.nav-bar-max {
  /* max-width: 1680px; */
  max-width: 1780px;
  height: 100%;
  padding-left: 17px;
  padding-right: 17px;
}

.nav-bar-mobile {
  background: linear-gradient(136.43deg, #360530 23.97%, #a23461 75.31%);
  width: 100%;
  min-height: 50px;
  padding: 9px 16px;
}

.nav-bar-mobile.bg-transparent {
  background: none;
  position: absolute;
  z-index: 999;
}

.nav-right-box {
  gap: 0 2rem;
}

.nav-search-box {
  background-color: rgba(255, 255, 255, 0.5);
  width: 157px;
  height: 25px;
  padding: 5px 15px 5px 12px;
  border-radius: 50px;
  min-width: 120px;
}

.nav-search-input {
  background-color: transparent;
  border: 0;
  outline: none;
  text-align: end;
  width: 100%;
  color: #5d5d5d;
  padding: 0;
  /* margin-top: 1.5px; */
  margin-left: 0.5rem;
  font-size: 14px;
}

.nav-font {
  color: #fff;
  margin-left: 4px;
  font-weight: 700;
  font-size: 16px;
}

.nav-count {
  font-weight: 700;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.5);
  width: 19px;
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 9px;
}

.nav-text-hover:hover {
  text-decoration: underline;
}

/* container */
.full_container {
  background-color: #efefef;
}

/* aside */
.aside-box {
  min-width: 195px;
  width: 170px;
  position: relative;
  overflow-y: auto;
  background-color: #fff;
  /* margin-right: 17px; */
  margin-right: 10px;
  /* padding-left: 120px; */
  padding-left: 10px;
  height: calc(100vh - 98px);
  z-index: 9;
}

.aside-container {
  /* display: flex; */
  /* justify-content: end; */
  /* width: 100%; */
  padding: 15px 0;
  margin-right: 8px;
}

.aside-container .accordion {
  min-width: 145px;
}

.aside-menu {
  display: flex;
  align-items: center;
}

.aside-box .accordion-margin-box {
  margin: 16px 0;
}

.aside-box .accordion-item2-margin {
  margin-bottom: 16px;
}

.aside-box .accordion-item {
  border: 0;
  background-color: initial;
  color: initial;
  cursor: pointer;
  margin-bottom: 7px;
}

.aside-box .accordion-item:last-child {
  /* margin-bottom: 60px; */
}

.aside-icon {
  width: 36px;
  height: 36px;
  margin-right: 0.5em;
}

.aside-box .accordion-item > a,
.aside-box .accordion-header {
  font-size: 15px;
  font-weight: 700 !important;
  color: #000;
  text-decoration: none;
  display: block;
  border-radius: 5px;
  /* padding: 0.25rem; */
}

.aside-box.bg-transparent .accordion-item > a {
  color: #fff;
}

.aside-box .accordion-button {
  padding: 0;
  background-color: initial;
  font-weight: 700;
  font-size: 13px;
}

.accordion-button:not(.collapsed) {
  color: initial !important;
  background-color: initial !important;
  box-shadow: initial !important;
}

.accordion-button:focus {
  box-shadow: initial !important;
}

.aside-box .accordion-button::after {
  background-image: initial;
  width: initial;
}

.aside-1-title {
  height: 26px;
  margin-bottom: 5px;
  line-height: 26px;
  padding: 0 7px;
}

.aside-sub {
  padding: 0 7px;
  height: 21px;
  line-height: 21px;
  color: #000;
  display: block;
  border-radius: 2.74px;
}

/* .aside-sub:hover {
  text-decoration: underline;
} */
.aside-sub-hover {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #971b4d;
  transform-origin: left;
  transform: scaleX(0);
  transition: transform 0.5s ease;
}

.aside-sub-text {
  display: inline-block;
  position: relative;
}

.aside-sub-text:hover .aside-sub-hover {
  transform: scaleX(1);
}

/* home */
.home_slides {
  height: 100vh;
  width: 100vw;
  position: relative;
}

.home_slides img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.home-arrow {
  color: #fff;
  font-size: 70px;
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
}

.active {
  background-color: #971b4d !important;
  color: #fbe5d6 !important;
}

.guide_tab.active {
  background-color: none !important;
}

.react-datepicker__children-container {
  overflow: hidden;
}

.bottom-sheet {
  position: fixed;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 96px;
  background-color: transparent;
  transition: height 0.3s ease-in-out;
  overflow: hidden;
  z-index: 99999;
}

.bottom-menu {
  height: 72.1px;
  padding: 0.5rem 1rem;
  max-width: 450px;
}

.bottom-text {
  color: #971b4d;
  font-weight: 700;
  white-space: nowrap;
}

.bottom-sheet-arrow {
  height: 14px;
  margin-bottom: -1px;
}

.bottom-content {
  height: calc(100% - 14px);
}

.bottom-active::after {
  content: '';
  width: 100%;
  height: 2px;
  background-color: #971b4d;
  position: absolute;
  bottom: 0px;
  left: 0;
}

/*scroll-bar*/
.scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.scroll::-webkit-scrollbar-thumb {
  background-color: #d9d9d9;
  /* border-radius: 4px; */
}

.scroll::-webkit-scrollbar-thumb:hover {
  background-color: #9f9f9f;
  /* border-radius: 4px; */
}

/* .scroll::-webkit-git -thumb:hover {
  background-color: #9f9f9f;
} */

.scroll::-webkit-scrollbar-track {
  background-color: #f2f2f2;
}

.w-33 {
  width: 33%;
}

.w-40 {
  width: 40%;
}

.w-65 {
  width: 65%;
}

.ps-10px {
  padding-left: 10px;
}

/* position */

.right-0 {
  right: 0;
}

/* background */
.bg-light-gray {
  background-color: #f2f2f2 !important;
}

.bg-light-purple {
  background-color: #dfe3ff;
}

.bg-light-pink {
  background-color: #ffdfdf;
}

.bg-light-green {
  background-color: #c1ffbe;
}

.bg-light-beige {
  background-color: #ffedc9;
}

.bg-purple {
  background-color: #971b4d;
}

/* color */
.text-light-gray {
  color: #ababab;
}

.text-gray {
  color: #7b7b7b;
}

.text-purple {
  color: #971b4d;
}

/* line height */
.lh-1 {
  line-height: 1;
}

/* border */
.bd-dashed {
  border: 2px dashed #b3b3b3;
}

.bd-bottom-dashed {
  border-bottom: 1px dashed #b3b3b3;
}

.bd-main {
  border: 1px solid #971b4d;
}

.page-up {
  z-index: 999;
  bottom: 3rem;
  right: 3rem;
}

/* table */
.table th,
.table td {
  vertical-align: middle;
}

/* swal */
div:where(.swal2-container) button:where(.swal2-styled) {
  box-shadow: none !important;
}

.home-container {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #ededed;
  /* min-height: 100vh; */
  height: 100vh;
  overflow: auto;
}

.home-container video {
  object-fit: cover;
}

.home-container::-webkit-scrollbar {
  display: none;
}

.nav-bar.bg-transparent::after {
  background-color: transparent;
}

p iframe {
  width: 100%;
}

@media (max-width: 1439px) {
  /* .nav-bar,
  .footer {
    padding-right: 24px;
    padding-left: 24px;
  } */

  .aside-box {
    /* padding-left: 24px; */
    min-width: 153px;
  }

  /* .my-container {
    padding-right: 24px;
  } */
}

.w-90 {
  width: 90%;
}

.qfs-15px {
  font-size: 15px;
}

.qfs-20px {
  font-size: 20px;
}

.qfs-32px {
  font-size: 32px;
}

.fw-400 {
  font-weight: 400;
}

.fw-700 {
  font-weight: 700;
}

.fw-800 {
  font-weight: 800;
}

.fw-900 {
  font-weight: 900;
}

.pointer {
  cursor: pointer;
}

.main {
  color: #971b4d !important;
}

.bg-main {
  background-color: #971b4d;
}

.bg-sub {
  background-color: #fbe5d6;
}

.word-keep-all {
  word-break: keep-all;
}

.flex-1 {
  flex: 1 1;
}

.white-nowrap {
  white-space: nowrap;
}

/* border-radius */
.bd-radius-5px {
  border-radius: 5px;
}

/* slider */

.slick-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.slick-dots li img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.slick-prev {
  left: 0 !important;
  z-index: 11;
}

.slick-next {
  right: 0 !important;
  z-index: 11;
}

.slick-prev:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
}

.slick-next:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
}

.swiper-button-prev:after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
}

.swiper-button-next:after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
}

/* .swiper_thumbnail_wrapper .swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
  width: 100%;
  height: 100%;
} */

.swiper_thumbnail_wrapper .swiper-slide .thumbnail_img_wrapper {
  border: 3px solid #fff;
}

.swiper_thumbnail_wrapper .swiper-slide-thumb-active.swiper-slide .thumbnail_img_wrapper {
  border: 3px solid #971b4d;
}

/* .swiper_thumbnail_wrapper .swiper-slide:hover {
  width: 110%;
  height: 110%;
} */

.hover_wrapper {
  color: #000;
}

.hover_wrapper:hover .mouse_hover {
  border-bottom: 1px solid #000;
}

.thumbnail_img_hover {
  width: 100%;
  aspect-ratio: 16 / 9 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.thumbnail_img_hover img,
.thumbnail_img_hover > div {
  width: 100% !important;
  height: 100% !important;
  transition: all 0.3s ease-in-out;
}

.thumbnail_img_hover svg {
  width: 40%;
  height: 40%;
  transition: all 0.3s ease-in-out;
}

.thumbnail_img_hover:hover img,
.thumbnail_img_hover:hover > div {
  width: 110% !important;
  height: 110% !important;
}

.thumbnail_img_hover:hover svg {
  width: 50%;
  height: 50%;
}

/* datePicker */

.cart_date_picker .react-datepicker {
  border: none !important;
}

.datePicker {
  height: 100%;
  width: 100%;
  cursor: pointer;
  border: rgb(204, 204, 204) 1px solid;
  outline: none;
  padding: 0.7rem 0.3rem;
}

.datePicker::placeholder {
  font-weight: 900;
}

.datePicker:focus {
  border: #000 1px solid;
}

.react-datepicker__input-container {
  height: 100% !important;
  width: 100% !important;
}

.react-datepicker {
  border: 1px solid #971b4d !important;
  border-radius: 0 !important;
  margin-top: 3px;
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  background-color: transparent !important;
}

.react-datepicker__day--outside-month {
  color: #c2c2c2 !important;
}

.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--selected,
.react-datepicker__year-text--in-selecting-range,
.react-datepicker__year-text--in-range {
  background-color: #971b4d !important;
}

.react-datepicker-wrapper {
  width: -webkit-fill-available;
}

.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after,
.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::after {
  content: none !important;
}

.react-datepicker-popper {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  z-index: 9999 !important;
}

.css-1u9des2-indicatorSeparator {
  width: 0 !important;
}

.custom-select-arrow {
  background-color: #f2f2f2;
  padding: 0 5px;
  margin-right: 4px;
}

.table > :not(caption) > * > * {
  white-space: nowrap;
}

.bg-dark-gray {
  background-color: #bfbfbf !important;
}

.table-bd-right-white {
  border-right: 5px solid #fff;
}

.table-bd-bottom-white {
  border-bottom: 5px solid #fff !important;
}

.table-bd-bottom-white-1 {
  border-bottom: 1px solid #fff !important;
}

.table-bd-top-white {
  border-top: 5px solid #fff !important;
}

.h-38px {
  height: 38px;
}

.modal-500px {
  width: 500px !important;
}

.left-0 {
  left: 0;
}

.home-text {
  width: max-content;
  position: absolute;
  color: #fff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);
  text-align: center;
  z-index: 999;
}

.bg-opacity-5 {
  background-color: rgba(90, 90, 90, 0.607);
  padding: 2rem 2.5rem;
}

.text-white.link {
  border-bottom: 1px solid #fff;
}

.mobile-home-first {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 75% / cover;
  height: calc(100vh - 58px);
  color: white;
}

.mobile-home-last {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 75% / cover;
  height: calc(100vh - 149.1px);
  color: white;
  position: relative;
}

.mobile-home-video {
  aspect-ratio: 1 / 1;
  height: 100vw;
  position: relative;
}

.mobile-home-video .home-text {
  transform: translate(-50%, -50%);
}

.mobile-home-video video {
  object-fit: cover;
}

.home-wrapper {
  padding-bottom: 72px;
  overflow: auto;
  height: 100%;
  position: relative;
}

.footer {
  background-color: #2a2a2a;
  color: #b9b7b6;
  bottom: 0;
}

.footer-content {
  max-width: 1680px;
}

.word-keep-all {
  word-break: keep-all;
}

.submit--btn {
  background-color: #971b4d;
  border-radius: 5px;
}

.cancel--btn {
  background-color: #f2f2f2;
  border-radius: 5px;
}

.mb-200px {
  margin-bottom: 200px;
}

/*
#react-select-8-listbox {
  background-color: rgba(255, 255, 255, 0.9);
} */

.detail_option {
  background-color: rgba(255, 255, 255, 0.9);
}

.modal-content {
  border-radius: 0 !important;
  border: 1px solid #971b4d !important;
}

.modal-cart-modal .modal-content,
.modal-media-cart-modal .modal-content {
  border-radius: 0 !important;
  background-color: rgb(255, 255, 255);
  border: 1px solid #971b4d;
}

.modal-media-cart-modal {
  justify-content: center;
}

.modal-media-cart-modal .modal-content {
  width: auto;
}

.table_text_height {
  line-height: 1.7;
}

.bd-right-white::after {
  content: '';
  width: 1px;
  height: 14px;
  margin: 0 0.5rem;
  background-color: #b9b7b6;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.swal2-container .swal2-modal {
  border: 1px solid #971b4d;
  border-radius: 0;
}

.mediaQuill .ql-container.ql-snow,
.mediaQuill .ql-toolbar.ql-snow {
  border: 0;
}

.mediaQuill > .ql-container > .ql-editor.ql-blank::before {
  color: #c2c2c2;
  font-size: 14px;
  line-height: 170%;
  font-style: normal !important;
}

.mediaQuill .ql-editor {
  height: 273px;
}

.mediaQuill .ql-editor::-webkit-scrollbar {
  width: 8px;
}

.mediaQuill .ql-editor::-webkit-scrollbar-thumb {
  background-color: #d9d9d9;
}

.mediaQuill .ql-editor::-webkit-scrollbar-thumb:hover {
  background-color: #7a7a7a;
}

.mediaQuill .ql-editor::-webkit-scrollbar-track {
  background-color: #f2f2f2;
}

.guide_tap {
  flex-wrap: nowrap !important;
}

.guide_tap.nav-tabs {
  border-bottom: none;
}

.guide_tap.nav-tabs .nav-link {
  border-radius: 0;
}

.guide_tap.nav {
  --bs-nav-link-color: #000;
  --bs-nav-link-hover-color: #000;
  font-size: 11px;
}

.guide_tap .nav-item {
  border: 1px solid #efefef;
  white-space: nowrap;
  font-weight: 700;
}

.guide_tap .nav-item button {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.react-datepicker__navigation-icon {
  top: 4px !important;
}

.nav-bar-max {
  padding-left: 2.4vw;
  padding-right: 2.4vw;
}

.aside-box {
  padding-left: 2.4vw;
  width: initial;
}

.my-container {
  padding-right: 2.4vw;
}

.footer-content {
  padding-left: 2.4vw;
}

.pb-90px {
  padding-bottom: 90px;
}

.vh-100 {
  height: calc((var(--vh, 1vh) * 100));
}

@media (max-width: 1679px) {
  /* .nav-bar-max {
    padding-left: 70px;
    padding-right: 70px;
  }

  .aside-box {
    padding-left: 70px;
    width: initial;
  }

  .my-container {
    padding-right: 70px;
  }

  .footer-content {
    padding-left: 70px;
  } */
}

@media (max-width: 1280px) {
  .page-up {
    bottom: 6rem;
    right: 2rem;
  }

  .footer {
    padding-bottom: 40px;
    padding-top: 10px;
  }

  .nav-bar {
    padding-right: 1rem;
    padding-left: 1rem;
  }

  .my-container {
    padding-right: 0;
  }

  .home-section-wrapper {
    padding-bottom: 72.1px;
  }

  .home-section-wrapper .position-absolute {
    bottom: 72.1px;
  }

  .nav-bar-max {
    padding-left: 8px;
    padding-right: 8px;
  }

  .home-arrow {
    bottom: 120px;
  }

  .bg_home2 {
    background-position: 70%;
  }
}

@media (max-width: 768px) {
  .modal-500px {
    width: 90vw !important;
  }

  .qfs-15px {
    font-size: 10px;
  }

  .qfs-20px {
    font-size: 14px;
  }

  .qfs-32px {
    font-size: 20px;
  }

  .nav-font {
    font-size: 10px;
  }

  .home-wrapper {
    padding-bottom: 56px;
  }

  .footer {
    padding-right: 16px;
    padding-left: 16px;
    padding-bottom: 16px;
  }

  .rialto-content-box {
    padding-top: 0;
  }

  .fs-6px {
    font-size: 6px;
  }

  .fs-7px {
    font-size: 7px;
  }

  .fs-9px {
    font-size: 9px;
  }

  .fs-10px {
    font-size: 10px;
  }

  .fs-11px {
    font-size: 11px;
  }

  .fs-12px {
    font-size: 12px;
  }

  .fs-13px {
    font-size: 13px;
  }

  .fs-14px {
    font-size: 14px;
  }

  .fs-15px {
    font-size: 15px;
  }

  .fs-16px {
    font-size: 16px;
  }

  .fs-18px {
    font-size: 18px;
  }

  .fs-20px {
    font-size: 20px;
  }

  .fs-26px {
    font-size: 26px;
  }

  .fs-28px {
    font-size: 28px;
  }

  /* .row > * {
    padding: 0 0.3rem;
  } */

  /*scroll-bar*/
  .scroll::-webkit-scrollbar {
    width: 5px;
    /* height: 83px; */
  }

  .scroll::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.5);
    /* border-radius: 4px; */
    border-radius: 10px;
  }

  .scroll::-webkit-scrollbar-track {
    background-color: transparent;
  }

  .bd-right-white::after {
    height: 10px;
  }

  .opacity-30 {
    height: 100vw;
    aspect-ratio: 1 / 1;
  }

  .home-text {
    transform: translate(-50%, -114%);
  }

  .mobile-home-last {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat 17% / cover;
    height: 100vh;
  }
}

@media (min-width: 769px) {
  .fs-6px {
    font-size: calc(6px * 1.33);
  }

  .fs-7px {
    font-size: calc(7px * 1.33);
  }

  .fs-9px {
    font-size: calc(9px * 1.33);
  }

  .fs-10px {
    font-size: calc(10px * 1.33);
  }

  .fs-11px {
    font-size: calc(11px * 1.33);
  }

  .fs-12px {
    font-size: calc(12px * 1.33);
  }

  .fs-13px {
    font-size: calc(13px * 1.33);
  }

  .fs-14px {
    font-size: calc(14px * 1.33);
  }

  .fs-15px {
    font-size: calc(15px * 1.33);
  }

  .fs-16px {
    font-size: calc(16px * 1.33);
  }

  .fs-18px {
    font-size: calc(18px * 1.33);
  }

  .fs-20px {
    font-size: calc(20px * 1.33);
  }

  .fs-26px {
    font-size: calc(26px * 1.33);
  }

  .fs-28px {
    font-size: calc(28px * 1.33);
  }
}

@media (max-width: 425px) {
  .fs-13px {
    font-size: 10px;
  }

  .custom-select-arrow img {
    width: 15px;
  }

  .mobile-home-first {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 73% 100% / 550% auto;
    height: calc(100vh - 58px);
    color: white;
  }
}

.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-height: 900px) {
  .aside-box .accordion-item {
    margin-bottom: 1px;
  }

  .aside-box .accordion-margin-box {
    margin: 1px 0;
  }

  .aside-box .accordion-item2-margin {
    margin-bottom: 1px;
  }

  .aside-box .aside-1-title {
    height: 20px;
  }

  .mobile-home-first-height {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 80% / cover;
  }
}

.aside-scroll::-webkit-scrollbar {
  display: none;
}

.aside-scroll {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0EAAoE;EACpE,WAAW;AACb;;AAEA;EACE,0EAAoE;EACpE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,SAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;;AAEA,QAAQ;AACR;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,WAAW;EACX,eAAe;EACf,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,OAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sEAAsE;EACtE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,aAAa;EACb,eAAe;EACf,WAAW;EACX,cAAc;EACd,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,qBAAqB;AACvB;;AAEA;;GAEG;AACH;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,OAAO;AACT;;AAEA,aAAa;AACb;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA,aAAa;;AAEb;EACE,QAAQ;AACV;;AAEA,eAAe;AACf;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA,UAAU;AACV;;EAEE,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;;;;KAIG;;EAEH;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;;KAEG;AACL;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA,WAAW;;AAEX;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2DAA6D;AAC/D;;AAEA;EACE,2DAA6D;AAC/D;;AAEA;EACE,2DAA6D;AAC/D;;AAEA;EACE,2DAA6D;AAC/D;;AAEA;;;;;;;;GAQG;;AAEH;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;GAGG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gCAAgC;AAClC;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,eAAe;;AAEf;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,oCAAoC;EACpC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;;;;EAIE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;EAYE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yEAAiE;EACjE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,yEAAiE;EACjE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;GAGG;;AAEH;EACE,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,2BAA2B;EAC3B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;;;;;;;;;;;;;;;;KAgBG;AACL;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;KAEG;;EAEH,aAAa;EACb;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;IACpC,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,yEAAwE;IACxE,aAAa;EACf;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kFAA0E;IAC1E,0BAA0B;IAC1B,YAAY;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yEAAiE;EACnE;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB","sourcesContent":["@import url(https://cdn.jsdelivr.net/gh/moonspam/NanumSquareNeo@1.0/nanumsquareneo.css);\n\nbody {\n  overscroll-behavior-y: none;\n}\n\n/* home */\n.outer {\n  scroll-behavior: smooth;\n  height: calc((var(--vh, 1vh) * 100));\n  scroll-snap-type: y mandatory;\n  overflow-y: scroll;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.outer > div {\n  scroll-snap-align: start;\n}\n\n.outer::-webkit-scrollbar {\n  display: none;\n}\n\n.inner {\n  height: 100%;\n  width: 100vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.bg_video {\n  height: 100%;\n  width: 100%;\n}\n\n.inner video {\n  object-fit: cover;\n}\n\n.bg_home1 {\n  background: url('../public/image/home_1.jpg') no-repeat 100% / cover;\n  color: #fff;\n}\n\n.bg_home2 {\n  background: url('../public/image/home_5.jpg') no-repeat 100% / cover;\n  color: #fff;\n}\n\n.bg-pink {\n  background-color: #f4cfdf;\n}\n\n* {\n  font-family: 'NanumSquareNeo';\n}\n\na {\n  text-decoration: none !important;\n}\n\np {\n  margin-bottom: 0 !important;\n}\n\n.rialto-container {\n  /* max-width: 1920px; */\n  width: 100%;\n  background-color: #fff;\n  /* height: 100vh; */\n  margin: 0 auto;\n  /* padding: 0 120px; */\n}\n\n.rialto-content-box {\n  padding-top: 98px;\n  background-color: #f2f2f2;\n  /* max-width: 1680px; */\n  max-width: 1765px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.my-container {\n  /* padding-right: 120px; */\n  /* width: 100%; */\n  flex: 1;\n}\n\n.opacity-30 {\n  background-color: rgba(0, 0, 0, 0.3);\n  height: 100%;\n  width: 100vw;\n  position: absolute;\n  top: 0;\n  z-index: 0;\n}\n\n/* nav */\n.nav-bar {\n  position: relative;\n  background: linear-gradient(178deg, #360530 16%, #a23461 78%);\n  /* max-width: 1920px; */\n  width: 100%;\n  height: 88px;\n  padding: 5px 0;\n  gap: 0 3rem;\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 999;\n}\n\n.nav-icons {\n  width: 14px;\n  height: 16px;\n}\n\n.nav-bar.bg-transparent {\n  background: none;\n}\n\n.nav-bar::after {\n  position: absolute;\n  bottom: -10px;\n  content: '';\n  width: 100%;\n  height: 10px;\n  background-color: #f2f2f2;\n  left: 0;\n}\n\n.nav-bar-max {\n  /* max-width: 1680px; */\n  max-width: 1780px;\n  height: 100%;\n  padding-left: 17px;\n  padding-right: 17px;\n}\n\n.nav-bar-mobile {\n  background: linear-gradient(136.43deg, #360530 23.97%, #a23461 75.31%);\n  width: 100%;\n  min-height: 50px;\n  padding: 9px 16px;\n}\n\n.nav-bar-mobile.bg-transparent {\n  background: none;\n  position: absolute;\n  z-index: 999;\n}\n\n.nav-right-box {\n  gap: 0 2rem;\n}\n\n.nav-search-box {\n  background-color: rgba(255, 255, 255, 0.5);\n  width: 157px;\n  height: 25px;\n  padding: 5px 15px 5px 12px;\n  border-radius: 50px;\n  min-width: 120px;\n}\n\n.nav-search-input {\n  background-color: transparent;\n  border: 0;\n  outline: none;\n  text-align: end;\n  width: 100%;\n  color: #5d5d5d;\n  padding: 0;\n  /* margin-top: 1.5px; */\n  margin-left: 0.5rem;\n  font-size: 14px;\n}\n\n.nav-font {\n  color: #fff;\n  margin-left: 4px;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.nav-count {\n  font-weight: 700;\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0.5);\n  width: 19px;\n  height: 19px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 9px;\n}\n\n.nav-text-hover:hover {\n  text-decoration: underline;\n}\n\n/* container */\n.full_container {\n  background-color: #efefef;\n}\n\n/* aside */\n.aside-box {\n  min-width: 195px;\n  width: 170px;\n  position: relative;\n  overflow-y: auto;\n  background-color: #fff;\n  /* margin-right: 17px; */\n  margin-right: 10px;\n  /* padding-left: 120px; */\n  padding-left: 10px;\n  height: calc(100vh - 98px);\n  z-index: 9;\n}\n\n.aside-container {\n  /* display: flex; */\n  /* justify-content: end; */\n  /* width: 100%; */\n  padding: 15px 0;\n  margin-right: 8px;\n}\n\n.aside-container .accordion {\n  min-width: 145px;\n}\n\n.aside-menu {\n  display: flex;\n  align-items: center;\n}\n\n.aside-box .accordion-margin-box {\n  margin: 16px 0;\n}\n\n.aside-box .accordion-item2-margin {\n  margin-bottom: 16px;\n}\n\n.aside-box .accordion-item {\n  border: 0;\n  background-color: initial;\n  color: initial;\n  cursor: pointer;\n  margin-bottom: 7px;\n}\n\n.aside-box .accordion-item:last-child {\n  /* margin-bottom: 60px; */\n}\n\n.aside-icon {\n  width: 36px;\n  height: 36px;\n  margin-right: 0.5em;\n}\n\n.aside-box .accordion-item > a,\n.aside-box .accordion-header {\n  font-size: 15px;\n  font-weight: 700 !important;\n  color: #000;\n  text-decoration: none;\n  display: block;\n  border-radius: 5px;\n  /* padding: 0.25rem; */\n}\n\n.aside-box.bg-transparent .accordion-item > a {\n  color: #fff;\n}\n\n.aside-box .accordion-button {\n  padding: 0;\n  background-color: initial;\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.accordion-button:not(.collapsed) {\n  color: initial !important;\n  background-color: initial !important;\n  box-shadow: initial !important;\n}\n\n.accordion-button:focus {\n  box-shadow: initial !important;\n}\n\n.aside-box .accordion-button::after {\n  background-image: initial;\n  width: initial;\n}\n\n.aside-1-title {\n  height: 26px;\n  margin-bottom: 5px;\n  line-height: 26px;\n  padding: 0 7px;\n}\n\n.aside-sub {\n  padding: 0 7px;\n  height: 21px;\n  line-height: 21px;\n  color: #000;\n  display: block;\n  border-radius: 2.74px;\n}\n\n/* .aside-sub:hover {\n  text-decoration: underline;\n} */\n.aside-sub-hover {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #971b4d;\n  transform-origin: left;\n  transform: scaleX(0);\n  transition: transform 0.5s ease;\n}\n\n.aside-sub-text {\n  display: inline-block;\n  position: relative;\n}\n\n.aside-sub-text:hover .aside-sub-hover {\n  transform: scaleX(1);\n}\n\n/* home */\n.home_slides {\n  height: 100vh;\n  width: 100vw;\n  position: relative;\n}\n\n.home_slides img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.home-arrow {\n  color: #fff;\n  font-size: 70px;\n  position: absolute;\n  bottom: 50px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 9;\n}\n\n.active {\n  background-color: #971b4d !important;\n  color: #fbe5d6 !important;\n}\n\n.guide_tab.active {\n  background-color: none !important;\n}\n\n.react-datepicker__children-container {\n  overflow: hidden;\n}\n\n.bottom-sheet {\n  position: fixed;\n  left: 0;\n  bottom: -1px;\n  width: 100%;\n  height: 96px;\n  background-color: transparent;\n  transition: height 0.3s ease-in-out;\n  overflow: hidden;\n  z-index: 99999;\n}\n\n.bottom-menu {\n  height: 72.1px;\n  padding: 0.5rem 1rem;\n  max-width: 450px;\n}\n\n.bottom-text {\n  color: #971b4d;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.bottom-sheet-arrow {\n  height: 14px;\n  margin-bottom: -1px;\n}\n\n.bottom-content {\n  height: calc(100% - 14px);\n}\n\n.bottom-active::after {\n  content: '';\n  width: 100%;\n  height: 2px;\n  background-color: #971b4d;\n  position: absolute;\n  bottom: 0px;\n  left: 0;\n}\n\n/*scroll-bar*/\n.scroll::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.scroll::-webkit-scrollbar-thumb {\n  background-color: #d9d9d9;\n  /* border-radius: 4px; */\n}\n\n.scroll::-webkit-scrollbar-thumb:hover {\n  background-color: #9f9f9f;\n  /* border-radius: 4px; */\n}\n\n/* .scroll::-webkit-git -thumb:hover {\n  background-color: #9f9f9f;\n} */\n\n.scroll::-webkit-scrollbar-track {\n  background-color: #f2f2f2;\n}\n\n.w-33 {\n  width: 33%;\n}\n\n.w-40 {\n  width: 40%;\n}\n\n.w-65 {\n  width: 65%;\n}\n\n.ps-10px {\n  padding-left: 10px;\n}\n\n/* position */\n\n.right-0 {\n  right: 0;\n}\n\n/* background */\n.bg-light-gray {\n  background-color: #f2f2f2 !important;\n}\n\n.bg-light-purple {\n  background-color: #dfe3ff;\n}\n\n.bg-light-pink {\n  background-color: #ffdfdf;\n}\n\n.bg-light-green {\n  background-color: #c1ffbe;\n}\n\n.bg-light-beige {\n  background-color: #ffedc9;\n}\n\n.bg-purple {\n  background-color: #971b4d;\n}\n\n/* color */\n.text-light-gray {\n  color: #ababab;\n}\n\n.text-gray {\n  color: #7b7b7b;\n}\n\n.text-purple {\n  color: #971b4d;\n}\n\n/* line height */\n.lh-1 {\n  line-height: 1;\n}\n\n/* border */\n.bd-dashed {\n  border: 2px dashed #b3b3b3;\n}\n\n.bd-bottom-dashed {\n  border-bottom: 1px dashed #b3b3b3;\n}\n\n.bd-main {\n  border: 1px solid #971b4d;\n}\n\n.page-up {\n  z-index: 999;\n  bottom: 3rem;\n  right: 3rem;\n}\n\n/* table */\n.table th,\n.table td {\n  vertical-align: middle;\n}\n\n/* swal */\ndiv:where(.swal2-container) button:where(.swal2-styled) {\n  box-shadow: none !important;\n}\n\n.home-container {\n  position: absolute;\n  width: 100%;\n  top: 0;\n  left: 0;\n  background-color: #ededed;\n  /* min-height: 100vh; */\n  height: 100vh;\n  overflow: auto;\n}\n\n.home-container video {\n  object-fit: cover;\n}\n\n.home-container::-webkit-scrollbar {\n  display: none;\n}\n\n.nav-bar.bg-transparent::after {\n  background-color: transparent;\n}\n\np iframe {\n  width: 100%;\n}\n\n@media (max-width: 1439px) {\n  /* .nav-bar,\n  .footer {\n    padding-right: 24px;\n    padding-left: 24px;\n  } */\n\n  .aside-box {\n    /* padding-left: 24px; */\n    min-width: 153px;\n  }\n\n  /* .my-container {\n    padding-right: 24px;\n  } */\n}\n\n.w-90 {\n  width: 90%;\n}\n\n.qfs-15px {\n  font-size: 15px;\n}\n\n.qfs-20px {\n  font-size: 20px;\n}\n\n.qfs-32px {\n  font-size: 32px;\n}\n\n.fw-400 {\n  font-weight: 400;\n}\n\n.fw-700 {\n  font-weight: 700;\n}\n\n.fw-800 {\n  font-weight: 800;\n}\n\n.fw-900 {\n  font-weight: 900;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.main {\n  color: #971b4d !important;\n}\n\n.bg-main {\n  background-color: #971b4d;\n}\n\n.bg-sub {\n  background-color: #fbe5d6;\n}\n\n.word-keep-all {\n  word-break: keep-all;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.white-nowrap {\n  white-space: nowrap;\n}\n\n/* border-radius */\n.bd-radius-5px {\n  border-radius: 5px;\n}\n\n/* slider */\n\n.slick-slide img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.slick-dots li img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.slick-prev {\n  left: 0 !important;\n  z-index: 11;\n}\n\n.slick-next {\n  right: 0 !important;\n  z-index: 11;\n}\n\n.slick-prev:before {\n  content: url(../public/image/icon/slider_prev.svg) !important;\n}\n\n.slick-next:before {\n  content: url(../public/image/icon/slider_next.svg) !important;\n}\n\n.swiper-button-prev:after {\n  content: url(../public/image/icon/slider_prev.svg) !important;\n}\n\n.swiper-button-next:after {\n  content: url(../public/image/icon/slider_next.svg) !important;\n}\n\n/* .swiper_thumbnail_wrapper .swiper-slide {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  transition: all 0.5s ease-in-out;\n  width: 100%;\n  height: 100%;\n} */\n\n.swiper_thumbnail_wrapper .swiper-slide .thumbnail_img_wrapper {\n  border: 3px solid #fff;\n}\n\n.swiper_thumbnail_wrapper .swiper-slide-thumb-active.swiper-slide .thumbnail_img_wrapper {\n  border: 3px solid #971b4d;\n}\n\n/* .swiper_thumbnail_wrapper .swiper-slide:hover {\n  width: 110%;\n  height: 110%;\n} */\n\n.hover_wrapper {\n  color: #000;\n}\n\n.hover_wrapper:hover .mouse_hover {\n  border-bottom: 1px solid #000;\n}\n\n.thumbnail_img_hover {\n  width: 100%;\n  aspect-ratio: 16 / 9 !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.thumbnail_img_hover img,\n.thumbnail_img_hover > div {\n  width: 100% !important;\n  height: 100% !important;\n  transition: all 0.3s ease-in-out;\n}\n\n.thumbnail_img_hover svg {\n  width: 40%;\n  height: 40%;\n  transition: all 0.3s ease-in-out;\n}\n\n.thumbnail_img_hover:hover img,\n.thumbnail_img_hover:hover > div {\n  width: 110% !important;\n  height: 110% !important;\n}\n\n.thumbnail_img_hover:hover svg {\n  width: 50%;\n  height: 50%;\n}\n\n/* datePicker */\n\n.cart_date_picker .react-datepicker {\n  border: none !important;\n}\n\n.datePicker {\n  height: 100%;\n  width: 100%;\n  cursor: pointer;\n  border: rgb(204, 204, 204) 1px solid;\n  outline: none;\n  padding: 0.7rem 0.3rem;\n}\n\n.datePicker::placeholder {\n  font-weight: 900;\n}\n\n.datePicker:focus {\n  border: #000 1px solid;\n}\n\n.react-datepicker__input-container {\n  height: 100% !important;\n  width: 100% !important;\n}\n\n.react-datepicker {\n  border: 1px solid #971b4d !important;\n  border-radius: 0 !important;\n  margin-top: 3px;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  background-color: transparent !important;\n}\n\n.react-datepicker__day--outside-month {\n  color: #c2c2c2 !important;\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n  background-color: #971b4d !important;\n}\n\n.react-datepicker-wrapper {\n  width: -webkit-fill-available;\n}\n\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after,\n.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::after {\n  content: none !important;\n}\n\n.react-datepicker-popper {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  z-index: 9999 !important;\n}\n\n.css-1u9des2-indicatorSeparator {\n  width: 0 !important;\n}\n\n.custom-select-arrow {\n  background-color: #f2f2f2;\n  padding: 0 5px;\n  margin-right: 4px;\n}\n\n.table > :not(caption) > * > * {\n  white-space: nowrap;\n}\n\n.bg-dark-gray {\n  background-color: #bfbfbf !important;\n}\n\n.table-bd-right-white {\n  border-right: 5px solid #fff;\n}\n\n.table-bd-bottom-white {\n  border-bottom: 5px solid #fff !important;\n}\n\n.table-bd-bottom-white-1 {\n  border-bottom: 1px solid #fff !important;\n}\n\n.table-bd-top-white {\n  border-top: 5px solid #fff !important;\n}\n\n.h-38px {\n  height: 38px;\n}\n\n.modal-500px {\n  width: 500px !important;\n}\n\n.left-0 {\n  left: 0;\n}\n\n.home-text {\n  width: max-content;\n  position: absolute;\n  color: #fff;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -70%);\n  text-align: center;\n  z-index: 999;\n}\n\n.bg-opacity-5 {\n  background-color: rgba(90, 90, 90, 0.607);\n  padding: 2rem 2.5rem;\n}\n\n.text-white.link {\n  border-bottom: 1px solid #fff;\n}\n\n.mobile-home-first {\n  background: url(../public/image/home_1.jpg) no-repeat 75% / cover;\n  height: calc(100vh - 58px);\n  color: white;\n}\n\n.mobile-home-last {\n  background: url(../public/image/home_5.jpg) no-repeat 75% / cover;\n  height: calc(100vh - 149.1px);\n  color: white;\n  position: relative;\n}\n\n.mobile-home-video {\n  aspect-ratio: 1 / 1;\n  height: 100vw;\n  position: relative;\n}\n\n.mobile-home-video .home-text {\n  transform: translate(-50%, -50%);\n}\n\n.mobile-home-video video {\n  object-fit: cover;\n}\n\n.home-wrapper {\n  padding-bottom: 72px;\n  overflow: auto;\n  height: 100%;\n  position: relative;\n}\n\n.footer {\n  background-color: #2a2a2a;\n  color: #b9b7b6;\n  bottom: 0;\n}\n\n.footer-content {\n  max-width: 1680px;\n}\n\n.word-keep-all {\n  word-break: keep-all;\n}\n\n.submit--btn {\n  background-color: #971b4d;\n  border-radius: 5px;\n}\n\n.cancel--btn {\n  background-color: #f2f2f2;\n  border-radius: 5px;\n}\n\n.mb-200px {\n  margin-bottom: 200px;\n}\n\n/*\n#react-select-8-listbox {\n  background-color: rgba(255, 255, 255, 0.9);\n} */\n\n.detail_option {\n  background-color: rgba(255, 255, 255, 0.9);\n}\n\n.modal-content {\n  border-radius: 0 !important;\n  border: 1px solid #971b4d !important;\n}\n\n.modal-cart-modal .modal-content,\n.modal-media-cart-modal .modal-content {\n  border-radius: 0 !important;\n  background-color: rgb(255, 255, 255);\n  border: 1px solid #971b4d;\n}\n\n.modal-media-cart-modal {\n  justify-content: center;\n}\n\n.modal-media-cart-modal .modal-content {\n  width: auto;\n}\n\n.table_text_height {\n  line-height: 1.7;\n}\n\n.bd-right-white::after {\n  content: '';\n  width: 1px;\n  height: 14px;\n  margin: 0 0.5rem;\n  background-color: #b9b7b6;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.swal2-container .swal2-modal {\n  border: 1px solid #971b4d;\n  border-radius: 0;\n}\n\n.mediaQuill .ql-container.ql-snow,\n.mediaQuill .ql-toolbar.ql-snow {\n  border: 0;\n}\n\n.mediaQuill > .ql-container > .ql-editor.ql-blank::before {\n  color: #c2c2c2;\n  font-size: 14px;\n  line-height: 170%;\n  font-style: normal !important;\n}\n\n.mediaQuill .ql-editor {\n  height: 273px;\n}\n\n.mediaQuill .ql-editor::-webkit-scrollbar {\n  width: 8px;\n}\n\n.mediaQuill .ql-editor::-webkit-scrollbar-thumb {\n  background-color: #d9d9d9;\n}\n\n.mediaQuill .ql-editor::-webkit-scrollbar-thumb:hover {\n  background-color: #7a7a7a;\n}\n\n.mediaQuill .ql-editor::-webkit-scrollbar-track {\n  background-color: #f2f2f2;\n}\n\n.guide_tap {\n  flex-wrap: nowrap !important;\n}\n\n.guide_tap.nav-tabs {\n  border-bottom: none;\n}\n\n.guide_tap.nav-tabs .nav-link {\n  border-radius: 0;\n}\n\n.guide_tap.nav {\n  --bs-nav-link-color: #000;\n  --bs-nav-link-hover-color: #000;\n  font-size: 11px;\n}\n\n.guide_tap .nav-item {\n  border: 1px solid #efefef;\n  white-space: nowrap;\n  font-weight: 700;\n}\n\n.guide_tap .nav-item button {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.react-datepicker__navigation-icon {\n  top: 4px !important;\n}\n\n.nav-bar-max {\n  padding-left: 2.4vw;\n  padding-right: 2.4vw;\n}\n\n.aside-box {\n  padding-left: 2.4vw;\n  width: initial;\n}\n\n.my-container {\n  padding-right: 2.4vw;\n}\n\n.footer-content {\n  padding-left: 2.4vw;\n}\n\n.pb-90px {\n  padding-bottom: 90px;\n}\n\n.vh-100 {\n  height: calc((var(--vh, 1vh) * 100));\n}\n\n@media (max-width: 1679px) {\n  /* .nav-bar-max {\n    padding-left: 70px;\n    padding-right: 70px;\n  }\n\n  .aside-box {\n    padding-left: 70px;\n    width: initial;\n  }\n\n  .my-container {\n    padding-right: 70px;\n  }\n\n  .footer-content {\n    padding-left: 70px;\n  } */\n}\n\n@media (max-width: 1280px) {\n  .page-up {\n    bottom: 6rem;\n    right: 2rem;\n  }\n\n  .footer {\n    padding-bottom: 40px;\n    padding-top: 10px;\n  }\n\n  .nav-bar {\n    padding-right: 1rem;\n    padding-left: 1rem;\n  }\n\n  .my-container {\n    padding-right: 0;\n  }\n\n  .home-section-wrapper {\n    padding-bottom: 72.1px;\n  }\n\n  .home-section-wrapper .position-absolute {\n    bottom: 72.1px;\n  }\n\n  .nav-bar-max {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  .home-arrow {\n    bottom: 120px;\n  }\n\n  .bg_home2 {\n    background-position: 70%;\n  }\n}\n\n@media (max-width: 768px) {\n  .modal-500px {\n    width: 90vw !important;\n  }\n\n  .qfs-15px {\n    font-size: 10px;\n  }\n\n  .qfs-20px {\n    font-size: 14px;\n  }\n\n  .qfs-32px {\n    font-size: 20px;\n  }\n\n  .nav-font {\n    font-size: 10px;\n  }\n\n  .home-wrapper {\n    padding-bottom: 56px;\n  }\n\n  .footer {\n    padding-right: 16px;\n    padding-left: 16px;\n    padding-bottom: 16px;\n  }\n\n  .rialto-content-box {\n    padding-top: 0;\n  }\n\n  .fs-6px {\n    font-size: 6px;\n  }\n\n  .fs-7px {\n    font-size: 7px;\n  }\n\n  .fs-9px {\n    font-size: 9px;\n  }\n\n  .fs-10px {\n    font-size: 10px;\n  }\n\n  .fs-11px {\n    font-size: 11px;\n  }\n\n  .fs-12px {\n    font-size: 12px;\n  }\n\n  .fs-13px {\n    font-size: 13px;\n  }\n\n  .fs-14px {\n    font-size: 14px;\n  }\n\n  .fs-15px {\n    font-size: 15px;\n  }\n\n  .fs-16px {\n    font-size: 16px;\n  }\n\n  .fs-18px {\n    font-size: 18px;\n  }\n\n  .fs-20px {\n    font-size: 20px;\n  }\n\n  .fs-26px {\n    font-size: 26px;\n  }\n\n  .fs-28px {\n    font-size: 28px;\n  }\n\n  /* .row > * {\n    padding: 0 0.3rem;\n  } */\n\n  /*scroll-bar*/\n  .scroll::-webkit-scrollbar {\n    width: 5px;\n    /* height: 83px; */\n  }\n\n  .scroll::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.5);\n    /* border-radius: 4px; */\n    border-radius: 10px;\n  }\n\n  .scroll::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n\n  .bd-right-white::after {\n    height: 10px;\n  }\n\n  .opacity-30 {\n    height: 100vw;\n    aspect-ratio: 1 / 1;\n  }\n\n  .home-text {\n    transform: translate(-50%, -114%);\n  }\n\n  .mobile-home-last {\n    background: url(../public/image/home_5_mobile.jpg) no-repeat 17% / cover;\n    height: 100vh;\n  }\n}\n\n@media (min-width: 769px) {\n  .fs-6px {\n    font-size: calc(6px * 1.33);\n  }\n\n  .fs-7px {\n    font-size: calc(7px * 1.33);\n  }\n\n  .fs-9px {\n    font-size: calc(9px * 1.33);\n  }\n\n  .fs-10px {\n    font-size: calc(10px * 1.33);\n  }\n\n  .fs-11px {\n    font-size: calc(11px * 1.33);\n  }\n\n  .fs-12px {\n    font-size: calc(12px * 1.33);\n  }\n\n  .fs-13px {\n    font-size: calc(13px * 1.33);\n  }\n\n  .fs-14px {\n    font-size: calc(14px * 1.33);\n  }\n\n  .fs-15px {\n    font-size: calc(15px * 1.33);\n  }\n\n  .fs-16px {\n    font-size: calc(16px * 1.33);\n  }\n\n  .fs-18px {\n    font-size: calc(18px * 1.33);\n  }\n\n  .fs-20px {\n    font-size: calc(20px * 1.33);\n  }\n\n  .fs-26px {\n    font-size: calc(26px * 1.33);\n  }\n\n  .fs-28px {\n    font-size: calc(28px * 1.33);\n  }\n}\n\n@media (max-width: 425px) {\n  .fs-13px {\n    font-size: 10px;\n  }\n\n  .custom-select-arrow img {\n    width: 15px;\n  }\n\n  .mobile-home-first {\n    background: url(../public/image/home_1.jpg) no-repeat 73% 100% / 550% auto;\n    height: calc(100vh - 58px);\n    color: white;\n  }\n}\n\n.text-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@media (max-height: 900px) {\n  .aside-box .accordion-item {\n    margin-bottom: 1px;\n  }\n\n  .aside-box .accordion-margin-box {\n    margin: 1px 0;\n  }\n\n  .aside-box .accordion-item2-margin {\n    margin-bottom: 1px;\n  }\n\n  .aside-box .aside-1-title {\n    height: 20px;\n  }\n\n  .mobile-home-first-height {\n    background: url(../public/image/home_1.jpg) no-repeat 80% / cover;\n  }\n}\n\n.aside-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.aside-scroll {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
